import { createAuth0Client } from "@auth0/auth0-spa-js";

let auth0Client = null;
let config = null;

export async function initAuth0() {
    if (auth0Client) return auth0Client;

    config = await fetch("/auth_config.json", { cache: "no-store" })
        .then((r) => r.json());

    auth0Client = await createAuth0Client({
        domain: config.domain,
        clientId: config.clientId,
        authorizationParams: {
            audience: config.audience,
            redirect_uri: `${window.location.origin}/admin.html`,
        },
    });

    return auth0Client;
}

export async function handleCallbackIfPresent() {
    if (!auth0Client) await initAuth0();

    const hasCode = window.location.search.includes("code=");
    const hasState = window.location.search.includes("state=");
    if (!hasCode || !hasState) return;

    await auth0Client.handleRedirectCallback(); 
    window.history.replaceState({}, document.title, "/admin.html");
}

export async function loginToAdmin() {
    if (!auth0Client) await initAuth0();
    await auth0Client.loginWithRedirect({
        authorizationParams: {
            audience: config.audience,
            redirect_uri: `${window.location.origin}/admin.html`,
        },
    });
}

export async function logoutToIndex() {
    if (!auth0Client) await initAuth0();
    await auth0Client.logout({
        logoutParams: { returnTo: `${window.location.origin}/index.html` },
    });
}

export async function isAuthed() {
    if (!auth0Client) await initAuth0();
    return auth0Client.isAuthenticated();
}

export async function getUser() {
    if (!auth0Client) await initAuth0();
    return auth0Client.getUser();
}

export async function getAccessToken() {
    if (!auth0Client) await initAuth0();
    return auth0Client.getTokenSilently({
        authorizationParams: { audience: config.audience },
    });
}
